import { z } from "zod";

import { IndustrialProcessSchema, IndustrialProcessType } from "../types";
import { isOutsourcingProcessStep } from "./isOutsourcingProcessStep";

export const isProductProcessStep = (processStep: {
  industrialProcess: IndustrialProcessType;
  isOutsourced?: boolean | null;
}) => {
  if (processStep.isOutsourced !== null && processStep.isOutsourced !== undefined) {
    return processStep.isOutsourced;
  }

  const productsProcessStepsType = [
    IndustrialProcessSchema.enum.MATERIAL,
    IndustrialProcessSchema.enum.PRODUCTS,
  ] as Array<z.infer<typeof IndustrialProcessSchema>>;

  return (
    productsProcessStepsType.includes(processStep.industrialProcess) ||
    isOutsourcingProcessStep(processStep)
  );
};
